import { useState, useEffect, useRef, Fragment} from 'react';
import './App.css';
import './Countdown.css';
import {
  Input,
  Button,
  Box,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  Link,
  Divider,
  Checkbox,
  Badge,
  VStack,
  StackDivider,
} from '@chakra-ui/react';

const isDebug = false;

// const API_ENTPOINT = 'http://133.242.157.238/';
const API_ENTPOINT = 'https://takata-anzan.com/';

const RESULT_CODE = {
  'new': 0
  , 'correct': 1
  , 'incorrect': 2
};

function toImgUrl(item) {
  if (item.indexOf('画像：http') >= 0) {
    var pattern = /(http.*)/;
    var result = item.match(pattern);
    var url = result[1];
    console.log(url);
    return <img src={url} />
  } else {
    return item;
  }
}

const QuestionTitle = ({title}) => {
  const texts = title.split(/(\n)/).map((item, index) => {
    return (
      <Fragment key={index}>
        { item.match(/\n/) ? <br /> : toImgUrl(item) }
      </Fragment>
    );
  });
  return <div>{texts}</div>;
};

function startCountdown(callbackFunction) {
  // ゲーム画面に移動
  let countT = 3800;
  if (isDebug) {
    countT = 300;
  }
  setTimeout(callbackFunction, countT);
}

function getCorrectCount(questions) {
  const count = questions.reduce((acc, cur) =>
    acc + (cur['status'] === 'correct' ? 1 : 0)
  , 0);
  return count;
}

function getIncorrectCount(questions) {
  const count = questions.reduce((acc, cur) =>
    acc + (cur['status'] === 'incorrect' ? 1 : 0)
    , 0);
  return count;
}

function getDispScore(score) {
  const minutes = Math.floor(score / 6000);
  const sec = Math.floor(score / 100 % 60);
  let msec = score % 100;
  if (msec === 0) {
    msec = '00';
  } else if (msec < 10) {
    msec = '0' + msec;
  } else {
    msec = '' + msec;
  }
  return {
    'minsec': (minutes ? minutes + '分' : '') + sec + '秒',
    'msec': msec
  };
}

function toQuestionParam(isCountDown, questions) {
  const qParam = [];
  for (let i = 0; i < questions.length; i++) {
    const q = questions[i];
    const qObj = {
      id: q.id
      , code: RESULT_CODE[q.status]
    };
    // isCountDownに関係なく、newじゃないqのみ乗せる
    if (q.status != 'new') {
      qParam.push(qObj);
    }
  }
  return qParam;
}
function App() {
  const maruSound = useRef(null);
  const batsuSound = useRef(null);
  const [currentScreen, setCurrentScreen] = useState('menu');
  const [nickname, setNickname] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [startTime, setStartTime] = useState(-1);
  const [score, setScore] = useState(-1);
  const [timer, setTimer] = useState(-1);
  const [rankings, setRankings] = useState([]);
  const [myRank, setMyRank] = useState(0);
  const [isRankingReadonly, setIsRankingReadonly] = useState(false);
  const [isLocalRanking, setIsLocalRanking] = useState(false);
  const [isClear, setIsClear] = useState(false);
  const [isSound, setIsSound] = useState(null);
  const [lastCurrentStartTime, setLastCurrentStartTime] = useState(null);
  const [correctCount, setCorrectCount] = useState(-1);
  const [incorrectCount, setIncorrectCount] = useState(-1);
  const [isCurrentCorrect, setCurrentCorrect] = useState(false);
  const [gameMode, setGameMode] = useState(new URL(window.location).search.substring(1).split('&').map((p) => p.split('=')).reduce((obj, e) => ({...obj, [e[0]]: e[1]}), {})['m']);
  const [gameKey, setGameKey] = useState(new URL(window.location).search.substring(1).split('&').map((p) => p.split('=')).reduce((obj, e) => ({...obj, [e[0]]: e[1]}), {})['t']);
  const [gameTitle, setGameTitle] = useState(null);
  const [authorName, setAuthorName] = useState(null);
  const [isCountDown, setIsCountDown] = useState(null);
  const [countDownTime, setCountDownTime] = useState(null);
  /**
  if (gameMode == null) {
    setGameMode('main');
  }
  if (gameKey == null) {
    setGameKey('sample');
  }
   */

  if (nickname === null) {
    // nicknameがnullのときだけ、初期値をセット
    const lastNickName = localStorage.getItem('nickname');
    setNickname(lastNickName ? lastNickName : '');
  }
  if (isSound === null) {
    // isSoundがnullのときだけ、初期値をセット
    const savedIsSound = localStorage.getItem('is_sound');
    const isChecked = savedIsSound === null ? true : savedIsSound === 'on';
    setIsSound(isChecked);
  }

  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {if (currentScreen === 'countdown') {startCountdown(function() { setStartTime(new Date().getTime());setCurrentScreen('gameScreen'); setLastCurrentStartTime(new Date().getTime());})}}, [currentScreen]);
  useEffect(() => {
    let interval = null;
    if (currentScreen === 'gameScreen') {
      if (isCountDown) {
        interval = setInterval(() => {
          const nowTime = (countDownTime * 1000) - (new Date().getTime() - startTime);
          // 最終問題の時
          if (nowTime <= 0) {
            clearInterval(interval);
            setIsClear(true);
            const scoreResult = endNormalMode(true);
            window.gtag('event', 'game_play_end', {
              'nickname': nickname,
              'event_label': 'math01',
              'event_category': 'game_play',
              'start_time': startTime,
              'end_time': scoreResult[0],
              'score': scoreResult[1]
            });
            setCurrentScreen('resultScreen');
            onClose();
            return;
          } else {
            setTimer(nowTime);
          }
        }, 48)
      } else {
        interval = setInterval(() => {
          setTimer(new Date().getTime() - startTime);
        }, 48)
      }
    } else {
      clearInterval(interval);
    }
    return () => clearInterval(interval)
  }, [currentScreen, startTime]);
  useEffect(()=>{
    maruSound.current = new Audio(process.env.PUBLIC_URL + '/maru.mp3');
    batsuSound.current = new Audio(process.env.PUBLIC_URL + '/batsu.mp3');
  },[]);
  useEffect(()=>{
    getGameInfo().then(function (game) {
      if (game['is_error']) {
        alert(game['error_message']);
        return;
      }
      setGameTitle(game['game_name']);
      setAuthorName(game['author_name']);
      // game_mode
      if (game['count_type'] === 'countdown') {
        setIsCountDown(true);
        setCountDownTime(+game['countdown_time']);
      } else {
        setIsCountDown(false);
        setCountDownTime(-1);
      }
    });

  }, []);

  //===========
  // Functions
  //===========
  function getRankingClassname(ranking) {
    let className = 'result-rank-row';
    if (ranking >= 1 && ranking <= 3) {
      className += ' result-rank-row-box result-rank-row-' + ranking;
    } else {
      className += ' result-rank-row-line';
      if (ranking >= 11) {
        className += ' result-rank-row-11-16';
      } else {
        className += ' result-rank-row-4-10';
      }
    }
    return className;
  }
  function ProgressBar() {
    return <div className="progressArea">
      {questions.map((question, questionIndex) =>
          // <span key={questionIndex}>{question['status'] === 'correct' ? '○' : (question['status'] === 'incorrect' ? '×' : '－')}</span>
        {
          let className = 'progress-dot ' + question['status'];
          if (questionIndex === (questions.length - 1)) {
            return <Fragment key={questionIndex}><div className={className}></div></Fragment>;
            // return <><div key={'dot' + questionIndex} className={className}></div></>;
            // return <><div key='dot' className={className}></div></>;
          } else {
            return <Fragment key={questionIndex}><div className={className}></div><div className="progress-line"></div></Fragment>;
            // return <><div key={'dot' + questionIndex} className={className}></div><div key={'line' + questionIndex} className="progress-line"></div></>;
            // return <><div key='dot' className={className}></div><div key='line' className="progress-line"></div></>;
          }
        }
      )}
    </div>;
  }
  function StatusBar() {
    return <div className="progressArea">
      <div style={{ 'fontSize': "0.7rem" }}>⭕{getCorrectCount(questions)}&nbsp;❌{getIncorrectCount(questions)}</div>
    </div>;
  }
  function getTimerDisp() {
    let score = Math.round(timer / 10);
    if (score % 100 === 0) {
      return '' + (score / 100) + '.00';
    }else if (score % 10 === 0) {
      return '' + (score / 100) + '0';
    } else {
      return '' + score / 100;
    }
  }
  async function getGameInfo() {
    const p = {
      'nickname': 'dummy'
      , 'app_name': 'anzan'
      , 'game_mode': gameMode
      , 'game_key': gameKey
    };
    const pStr = encodeURIComponent(JSON.stringify(p));
    const url = API_ENTPOINT + 'api/api.php?mode=s&p=' + pStr;
    // console.log(url);
    const response = await fetch(url, {method: 'GET', mode: 'cors'});
    // .then(response => response.json())
    // .then(data => console.log(data));
    return response.json();
  }
  async function getQuestions(newNickname) {
    const p = {
      'nickname': newNickname
      , 'app_name': 'anzan'
      , 'game_mode': gameMode
      , 'game_key': gameKey
    };
    const pStr = encodeURIComponent(JSON.stringify(p));
    const url = API_ENTPOINT + 'api/api.php?mode=q&p=' + pStr;
    // console.log(url);
    const response = await fetch(url, {method: 'GET', mode: 'cors'});
    // .then(response => response.json())
    // .then(data => console.log(data));
    return response.json();
  }
  async function getRankingsReadonly() {
    const p = {
      'nickname': nickname ? nickname : 'empty'
      , 'app_name': 'anzan'
      , 'game_mode': gameMode
      , 'game_key': gameKey
    };
    const pStr = encodeURIComponent(JSON.stringify(p));
    const url = API_ENTPOINT + 'api/api.php?mode=g&p=' + pStr;
    const response = await fetch(url, {method: 'GET', mode: 'cors'});
    return response.json();
  }
  async function getRankings(score, isComplete) {
    const p = {
      'nickname': nickname
      , 'app_name': 'anzan'
      , 'game_mode': gameMode
      , 'game_key': gameKey
      , 'startTime': startTime
      , 'score': score
      , 'isComplete': isComplete
      , 'questions': toQuestionParam(isCountDown, questions)
    };
    const pStr = encodeURIComponent(JSON.stringify(p));
    const url = API_ENTPOINT + 'api/api.php?mode=r&p=' + pStr;
    const response = await fetch(url, {method: 'GET', mode: 'cors'});
    return response.json();
  }
  function viewRankings() {
    setCorrectCount(-1);
    setIncorrectCount(-1);
    getRankingsReadonly().then(function (data) {
      if (data['rankings']) {
        setRankings(data['rankings']);
      } else {
        setRankings([]);
      }
      setIsRankingReadonly(data['isReadonly']);
      setIsLocalRanking(data['isLocal']);
      setCurrentScreen('resultScreen');
    });
  }
  function startNewGame() {
    let newNickname = nickname;
    // 入力されていれば、エラーチェック、されていなければ「匿名さん」で始める
    if (newNickname) {
      if (!isValidNickname(newNickname)) {
        alert('ニックネームが長すぎるか使えない文字が含まれています');
        return;
      }
    } else {
      setNickname('匿名さん');
      newNickname = '匿名さん';
    }
    window.gtag('event', 'game_play_start', {
      'nickname': newNickname,
      'event_label': 'anzan',
      'event_category': 'game_play'
      , 'game_mode': gameMode
      , 'game_key': gameKey
    });
    getQuestions(newNickname).then(function (questions) {
      if (questions['is_error']) {
        alert(questions['error_message']);
        return;
      }
      // questionsに、status: 'new' をセット
      questions = questions.map(question =>
        ({...question, status: 'new', answerIndex: -1})
      );
      // reset処理
      setIsClear(false);
      setMyRank(0);
      setIsRankingReadonly(false);
      setRankings([]);
      setCurrentQuestionIndex(0);
      //TODO countdown削除
      if (isDebug) {
        setQuestions([questions[0], questions[1], questions[2]]);
      } else {
        setQuestions(questions);
      }
      // setCurrentScreen('countdown');
      setStartTime(new Date().getTime());
      setCurrentScreen('gameScreen');
      setLastCurrentStartTime(new Date().getTime());
    });
    // 20問
    /**
     const questions = [
     {'kake1': 4, 'kake2': 8, options: [30, 32, 34, 38], correctIdx: 1, answer: 32, status: 'new'}
     , {'kake1': 2, 'kake2': 8, options: [30, 32, 12, 38], correctIdx: 2, answer: 12, status: 'new'}
     , {'kake1': 10, 'kake2': 10, options: [100, 123, 900, 604], correctIdx: 0, answer: 100, status: 'new'}
     ];
     */
  }
  function selectAnswer(optionIndex) {
    const isCorrect = (optionIndex === questions[currentQuestionIndex]['correctIdx']);
    if (isSound) {
      maruSound.current.pause();
      maruSound.current.currentTime = 0;
      batsuSound.current.pause();
      batsuSound.current.currentTime = 0;
      if (isCorrect) {
        maruSound.current.play();
      } else {
        batsuSound.current.play();
      }
    }
    const currentEndTime = new Date().getTime();
    const questionTime = currentEndTime - lastCurrentStartTime;
    setCurrentCorrect(isCorrect);
    window.gtag('event', 'game_play_answer', {
      'nickname': nickname,
      'event_label': 'math01',
      'event_category': 'game_play',
      'question_index': currentQuestionIndex,
      'question_no': currentQuestionIndex + 1,
      'question_id': questions[currentQuestionIndex]['id'],
      'question_time': questionTime,
      'question_start_time': lastCurrentStartTime,
      'question_end_time': currentEndTime,
      'start_time': startTime,
      'is_correct': isCorrect
    });
    /** 間違ったらTOPに戻す処理
    if (!isCorrect) {
      setCurrentScreen('menu');
    }
     */
    // ==================
    // 結果通知エフェクト
    // ==================
    /**
    onOpen();
    let countT = 600;
    if (isDebug) {
      countT = 600;
    }
    setTimeout(function() {
      // 演出終わった後
      updateQuestionStatus(currentQuestionIndex, isCorrect ? 'correct' : 'incorrect');
      // 最終問題のとき
      if (currentQuestionIndex === questions.length - 1) {
        setIsClear(true);
        const scoreResult = endNormalMode(true);
        window.gtag('event', 'game_play_end', {
          'nickname': nickname,
          'event_label': 'math01',
          'event_category': 'game_play',
          'start_time': startTime,
          'end_time': scoreResult[0],
          'score': scoreResult[1]
        });
        setCurrentScreen('resultScreen');
        onClose();
        return;
      }
      setLastCurrentStartTime(new Date().getTime());
      setCurrentQuestionIndex(currentQuestionIndex + 1);
      onClose();
    }, countT);
     */
    // 演出終わった後
    updateQuestionStatus(currentQuestionIndex, isCorrect ? 'correct' : 'incorrect');
    updateQuestionAnswerIndex(currentQuestionIndex, optionIndex);
    // 最終問題のとき
    if (currentQuestionIndex === questions.length - 1) {
      setIsClear(true);
      const scoreResult = endNormalMode(true);
      window.gtag('event', 'game_play_end', {
        'nickname': nickname,
        'event_label': 'math01',
        'event_category': 'game_play',
        'start_time': startTime,
        'end_time': scoreResult[0],
        'score': scoreResult[1]
      });
      setCurrentScreen('resultScreen');
      onClose();
      return;
    }
    setLastCurrentStartTime(new Date().getTime());
    setCurrentQuestionIndex(currentQuestionIndex + 1);
  }
  // 最後の問題を解いた時。backボタン押した時は呼ばない
  function endNormalMode(isComplete) {
    // 正解数
    setCorrectCount(getCorrectCount(questions));
    // 不正回数
    setIncorrectCount(getIncorrectCount(questions));
    // Score
    const endTime = new Date().getTime();
    let score = null;
    if (isCountDown) {
      score = Math.round((98.76 * getCorrectCount(questions)) - (123.45 * getIncorrectCount(questions)));
      if (score <= 0) {
        score = 0;
      }
    } else {
      score = Math.floor((endTime - startTime) / 10);
    }
    setScore(score);
    getRankings(score, isComplete).then(function (data) {
      if (data['rankings']) {
        setRankings(data['rankings']);
      } else {
        setRankings([]);
      }
      if (data['myrank']) {
        setMyRank(data['myrank']);
      } else {
        setMyRank(0);
      }
      setIsRankingReadonly(data['isReadonly']);
      setIsLocalRanking(data['isLocal']);
    });
    return [endTime, score];
  }

  function updateQuestionStatus(index, newValue) {
    updateQuestionValue(index, 'status', newValue);
  }

  function updateQuestionAnswerIndex(index, newValue) {
    updateQuestionValue(index, 'answerIndex', newValue);
  }

  function updateQuestionValue(index, columnName, newValue) {
    questions[index][columnName] = newValue;
    setQuestions(questions);
  }

  function onClickBack() {
    setCurrentScreen('menu');
  }

  function isValidNickname(nick) {
    if (!nick) {
      return false;
    }
    if (!nick.match(/^[ぁ-んァ-ヶｱ-ﾝﾞﾟ一-龠0-9a-zA-Zーａ-ｚＡ-Ｚ０-９]*$/)) {
      return false;
    }
    if (nick.length > 15) {
      return false;
    }
    return true;
  }
  function onChangeNickname(e) {
    // /^[ぁ-んァ-ヶｱ-ﾝﾞﾟ一-龠0-9a-zA-Z]*$/
    const nick = e.currentTarget.value;
    setNickname(e.currentTarget.value);
    localStorage.setItem('nickname', nick);
  }
  function onChangeCheckbox(e) {
    const is_sound = e.currentTarget.checked;
    setIsSound(is_sound);
    localStorage.setItem('is_sound', (is_sound ? 'on' : 'off'));
  }
  return (
    <div className="App">
      <header className="header">
        {currentScreen !== 'menu' && currentScreen !== 'countdown' && <img className="back-button" alt="back" src={`${process.env.PUBLIC_URL}/back.svg`} onClick={() => onClickBack()} width="32px" height="32px" />}
      </header>
      <div>
        { currentScreen === 'menu' &&
        <div className="menu-contents">
          <div className="title-image-container">
            <img className="title-image" src="title.jpg" alt="バク速！計算ゲーム" />
          </div>
          <h2 class="game-title">
            <span class="game-title-text">{gameTitle}</span>
          </h2>
          <div>
            <div className="nickname-label">ニックネーム</div>
            <Input
              isInvalid={!isValidNickname(nickname)}
              id="input_nickname"
              value={nickname}
              onChange={onChangeNickname}
              placeholder='匿名さん'
              size='lg'
            />
          </div>
          <div>
            <Button colorScheme='red' size='lg' onClick={() => startNewGame()}>
              START
            </Button>
          </div>
          <div>
            <Button colorScheme='red' size='lg' onClick={() => viewRankings()}>
              ランキング
            </Button>
          </div>
          <div>
            <Checkbox size='sm' colorScheme='red' onChange={onChangeCheckbox} isChecked={isSound}><span className='is-sound-check'>効果音</span></Checkbox>
          </div>
          <Divider style={{ 'marginTop': "3rem" }} />
          <span style={{ 'fontSize': "0.5rem" }}>問題作成者名：{authorName}</span>
          <Divider style={{ 'marginTop': "1rem" }} />
          <footer>
            <p>
              <Link color='red.500' href="/privacypolicy.html" target="_blank" rel="noopener noreferrer" style={{ 'fontSize': "0.5rem" }}>プライバシーポリシー</Link>
            </p>
            <p>©STUDY FREAK</p>
          </footer>
        </div>}
        { currentScreen === 'countdown' &&
        <div className="countdown-contents">
          <div className="demo">
            <div className="demo__colored-blocks">
              <div className="demo__colored-blocks-rotater">
                <div className="demo__colored-block"></div>
                <div className="demo__colored-block"></div>
                <div className="demo__colored-block"></div>
              </div>
              <div className="demo__colored-blocks-inner"></div>
              <div className="demo__text">Ready</div>
            </div>
            <div className="demo__inner">
              <svg className="demo__numbers" viewBox="0 0 100 100">
                <defs>
                  <path className="demo__num-path-1" d="M40,28 55,22 55,78"/>
                  <path className="demo__num-join-1-2" d="M55,78 55,83 a17,17 0 1,0 34,0 a20,10 0 0,0 -20,-10"/>
                  <path className="demo__num-path-2" d="M69,73 l-35,0 l30,-30 a16,16 0 0,0 -22.6,-22.6 l-7,7"/>
                  <path className="demo__num-join-2-3" d="M28,69 Q25,44 34.4,27.4"/>
                  <path className="demo__num-path-3" d="M30,20 60,20 40,50 a18,15 0 1,1 -12,19"/>
                </defs>
                <path className="demo__numbers-path"
                      d="M-10,20 60,20 40,50 a18,15 0 1,1 -12,19
               Q25,44 34.4,27.4
               l7,-7 a16,16 0 0,1 22.6,22.6 l-30,30 l35,0 L69,73
               a20,10 0 0,1 20,10 a17,17 0 0,1 -34,0 L55,83
               l0,-61 L40,28" />
              </svg>
            </div>
          </div>
        </div>}
        { currentScreen === 'gameScreen' &&
        <div className="game-contents">
          <div className="game-header">
            <span className="nickname">{nickname}</span>
            <span className="timer">{getTimerDisp(timer)}</span>
          </div>
          { !isCountDown ?
            <ProgressBar />
            :
            <StatusBar />
          }
          <Box w='100%' bgGradient='linear(yellow.100 0%, yellow.100 25%, yellow.100 50%)'>
            <div className="solution-container">
              <div className="question"><QuestionTitle title={questions[currentQuestionIndex].title} /></div>
              {questions[currentQuestionIndex].options.map((opt, optionIndex) =>
                <Button
                  key={optionIndex}
                  onClick={() => selectAnswer(optionIndex)}
                  className="solution"
                  size='md'
                  border='2px'
                >
                  {opt}
                </Button>
              )}
            </div>
          </Box>
          <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose} isCentered className="transparent-popup">
            <ModalOverlay className="popup-overlay"/>
            <ModalContent className="transparent-popup">
              <img className="marubatsu" alt="marubatsu" src={`${process.env.PUBLIC_URL}/${isCurrentCorrect ? 'maru' : 'batsu'}.svg`} width="200px" height="200px" />
            </ModalContent>
          </Modal>
        </div>}
        { currentScreen === 'resultScreen' &&
        <div>
          <div className="game-header">
            <span className="nickname">{nickname}</span>
          </div>
          { correctCount >= 0 && !isCountDown &&
            <ProgressBar />
          }
          <div className="result-contents">
            { correctCount >= 0 &&
              <>
              <div className="result-label">正解数</div>
              {isCountDown ?
                <div className="result-image-container">
                  <p style={{ 'fontSize': "0.7rem" }}>⭕{correctCount}&nbsp;❌{incorrectCount}</p>
                  <img src="result.jpg" className="result-image" alt="ブラボー" />
                </div>
                :
                <div className="result-image-container">
                  <span style={{ 'fontSize': "2rem" }}>{correctCount}問</span><span>／{questions.length}問</span>
                  <img src="result.jpg" className="result-image" alt="ブラボー" />
                </div>
              }
              <div>
                { (!isCountDown && correctCount === questions.length) &&
                <span className="all-clear-text">全問正解！</span>
                }
              </div>
              {isCountDown ?
                <>
                <div className="result-label">スコア</div>
                <div className="result-time-bar">
                  <span className="result-score">{score}</span>
                  { myRank > 0 &&
                  <span className="result-rank">{myRank} 位</span>
                  }
                </div>
                </>
                :
                <>
                <div className="result-label">総合タイム</div>
                <div className="result-time-bar">
                  <span className="result-score">{getDispScore(score)['minsec']}<small>{getDispScore(score)['msec']}</small></span>
                  { myRank > 0 &&
                  <span className="result-rank">{myRank} 位</span>
                  }
                </div>
                </>
              }
              </>
            }
            <div>
              { (isRankingReadonly && !isLocalRanking) &&
              <>
              <div className="result-label-center">全国スコアランキング</div>
              {rankings.map((ranking, rankingIndex) =>
                <Box key={rankingIndex} w='100%' className={getRankingClassname(rankingIndex + 1)}>
                  <span className="result-rank-num">{ranking['rank']}</span>
                  <span className="result-rank-nickname">{ranking['nickname']}</span>
                  {isCountDown ?
                    <span className="result-rank-score">{ranking['score']}</span>
                    :
                    <span className="result-rank-score">{getDispScore(ranking['score'])['minsec']}<small>{getDispScore(ranking['score'])['msec']}</small></span>
                  }
                </Box>
              )}
              </>
              }
              { (!isRankingReadonly || isLocalRanking) &&
              <>
              <div className="result-label">個人スコアランキング</div>
              {rankings.map((ranking, rankingIndex) =>
                <Box key={rankingIndex} w='100%' className={getRankingClassname(rankingIndex + 1)}>
                  <span className="result-rank-num">{ranking['rank']}</span>
                  <span className="result-rank-nickname">{ranking['nickname']}</span>
                  <span className="result-rank-datetime">{ranking['created_at'].substring(0, 10)}</span>
                  {isCountDown ?
                    <span className="result-rank-score">{ranking['score']}</span>
                    :
                    <span className="result-rank-score">{getDispScore(ranking['score'])['minsec']}<small>{getDispScore(ranking['score'])['msec']}</small></span>
                  }
                </Box>
              )}
              </>
              }
            </div>
            {correctCount >= 0  &&
            <>
            <div className="result-label">見直し</div>
            <div className="result-review">
              {
                questions.map((question, questionIndex) =>
                <div key={questionIndex}>
                  {question['status'] !== 'new' &&
                  <Box w='100%' mb="4" className="result-review-box" bgGradient='linear(yellow.100 0%, yellow.100 25%, yellow.100 50%)'>
                    <Box className="solution-container">
                      <VStack spacing={2} align='stretch'>
                        <Box>
                          問{(questionIndex + 1)}
                          <br/>
                          <QuestionTitle title={question.title} />
                        </Box>
                        {question.options.map((opt, optionIndex) =>
                          <Box className="result-review-question-box" key={questionIndex + "_" + optionIndex}>
                            <div className="result-review-question-box-answer-before">
                              { (question.correctIdx == optionIndex && question.answerIndex == optionIndex) &&
                              <Badge colorScheme='green'>○答</Badge>
                              }
                              { (question.correctIdx == optionIndex && question.answerIndex != optionIndex) &&
                              <Badge colorScheme='red'>答</Badge>
                              }
                              { (question.correctIdx != optionIndex && question.answerIndex == optionIndex) &&
                              <Badge colorScheme='red'>×</Badge>
                              }
                            </div>
                            <div className="result-review-question-box-answer">
                              {opt}
                            </div>
                            <div className="result-review-question-box-answer-after">
                              { (question.correctIdx == optionIndex && question.answerIndex == optionIndex) &&
                              <Badge colorScheme='green'>○答</Badge>
                              }
                              { (question.correctIdx == optionIndex && question.answerIndex != optionIndex) &&
                              <Badge colorScheme='red'>答</Badge>
                              }
                              { (question.correctIdx != optionIndex && question.answerIndex == optionIndex) &&
                              <Badge colorScheme='red'>×</Badge>
                              }
                            </div>
                          </Box>
                        )}
                      </VStack>
                    </Box>
                  </Box>
                  }
                </div>
              )}
            </div>
            </>
            }
          </div>
        </div>}
      </div>
    </div>
  );
}
export default App;
